import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from '@angular/forms';
import { TimePickerComponent } from "./time-picker.component";
import { TimePickerModalService } from "./time-picker-shared/providers/time-picker-modal.service";
import { TimePickerModalComponent } from "./time-picker-modal/time-picker-modal.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";

@NgModule({
  imports: [CommonModule, MatInputModule, MatFormFieldModule, MatIconModule, ReactiveFormsModule],
  declarations: [TimePickerComponent, TimePickerModalComponent],
  exports: [TimePickerComponent],
  providers: [TimePickerModalService],
})
export class TimePickerModule {}
